module.exports = __webpack_public_path__ + "img/undraw_cooking.ed4bce39.svg";